import { render, staticRenderFns } from "./TranslationSwitch.vue?vue&type=template&id=4343492b&scoped=true&"
import script from "./TranslationSwitch.vue?vue&type=script&lang=js&"
export * from "./TranslationSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TranslationSwitch.vue?vue&type=style&index=0&id=4343492b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4343492b",
  null
  
)

component.options.__file = "TranslationSwitch.vue"
export default component.exports